import { useTranslation } from 'react-i18next'
import Button from '@ui/buttons/Button'
import { ButtonProps } from '@ui/buttons/Button/types'
import { colors } from '@ui/colors'

export default function PaymentHelpButton(props: ButtonProps) {
  const { t } = useTranslation(['payment'])
  const text = 'payment:actions.button'
  return (
    <Button
      variant="outlined"
      size="xs"
      label={t(text)}
      className="w-max self-center"
      overrideColorFront={colors.black50}
      {...props}
    />
  )
}
